import React, { useState } from 'react';

const Button = ({ type = 'primary', children, icon, onClick, className = '', htmlType, value }) => {
    const [isPressed, setIsPressed] = useState(false);

    const baseStyles = 'inline-flex flex-row gap-2 items-center justify-center rounded-lg font-bold focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-2 transition-all duration-200';

    const sizeStyles = {
        primary: 'px-6 py-3 text-base md:px-8 md:py-3.5 md:text-lg',
        secondary: 'px-6 py-3 text-base',
        text: 'px-3 py-2 text-base',
        icon: 'p-2',
    };

    const colorStyles = {
        primary: 'bg-brand-800 text-white hover:bg-brand-900 active:bg-brand-900',
        secondary: 'bg-surfaceTwo text-textBody hover:bg-grey-200',
        text: 'bg-transparent text-brand-800 hover:text-brand-900 hover:bg-brand-100',
        icon: 'bg-transparent hover:bg-brand-100',
    };

    const activeStyles = isPressed ? 'scale-[0.97]' : '';

    return (
        <button
            type={htmlType || 'button'}
            value={value}
            className={`${baseStyles} ${sizeStyles[type]} ${colorStyles[type]} ${activeStyles} ${className}`}
            onMouseDown={() => setIsPressed(true)}
            onMouseUp={() => setIsPressed(false)}
            onMouseLeave={() => setIsPressed(false)}
            onClick={onClick}
        >
            {icon && <span>{icon}</span>}
            {children}
        </button>
    );
};

export default Button;
